import type {CurrentWord} from '$lib/stores/currentWord';
import type {WordId} from '$lib/classes/data/_primitives';
import type {DisplayWords} from '$lib/stores/displayWords';
import {get} from 'svelte/store';
import type {FilterSettings} from '$lib/stores/filterSettings';
import {goto} from '$app/navigation';
import type {Word} from '$lib/classes/data/word';

export class BrowseNavigator {

    constructor(
        private readonly filterSettings: FilterSettings,
        private readonly displayWords: DisplayWords,
        private readonly currentWord: CurrentWord
    ) {}

    setFirstWordAsCurrent() {
        const firstWord = get(this.displayWords)[0];
        if (firstWord) {
            this.currentWord.setCurrentWord(firstWord);
        }
    }

    // TODO handle ALL currentWord.setCurrentWord calls from here ?!?
    // NOTE check for wordFound.id !== currentWordId important for english routing!?
    async navigateViaWordId(wordId: WordId, replaceState = false) {
        const currentWordId = get(this.currentWord)?.id;
        const wordFoundInDisplayWords = get(this.displayWords).find(word => word.id === wordId);
        if (wordFoundInDisplayWords) {
            if (wordFoundInDisplayWords.id !== currentWordId) {
                this.currentWord.setCurrentWord(wordFoundInDisplayWords);
                await goto(`/browse/${wordId}`, {replaceState});
            }
        } else {
            this.filterSettings.resetAll()
            const wordFoundInAllWords = get(this.displayWords).find(word => word.id === wordId);
            if (wordFoundInAllWords) {
                if (wordFoundInAllWords.id !== currentWordId) {
                    this.currentWord.setCurrentWord(wordFoundInAllWords);
                    await goto(`/browse/${wordId}`, {replaceState});
                }
            } else {
                // NO WORD FOUND
                await goto('/browse', {replaceState: true})
            }
        }
    }

    async navigateViaWord(word: Word) {
        const currentWordId = get(this.currentWord)?.id;
        this.currentWord.setCurrentWord(word)
        if (word.id !== currentWordId) {
            await goto(`/browse/${word.id}`);
        }
    }
}